import { axios } from '@/plugins/axios';

export default class ScriptsConfigService
{
    public static async getModules(moduleId: string): Promise<any[]>
    {
        return (
            await axios.get('simple-dictionary/scripts/form/module', {
                params: {
                    index: 1,
                    size: 100,
                    order: 'ASC',
                    moduleId: moduleId
                },
            })
        ).data;
    }

    public static async getSchema(publicId: string, moduleId: string): Promise<any>
    {
        return (
            await axios.get(`scripts/config/${publicId}/schema`, {
                params: {
                    moduleId: moduleId
                },
            })
        ).data;
    }

    public static async getConfig(configId: string, moduleId: string): Promise<any>
    {
        return (await axios.get(`simple-fetch/scripts-config/${configId}`, {
            params: {
                moduleId: moduleId
            }
        })).data;
    }

    public static async getDefaultConfigId(scriptId: string, moduleId: string): Promise<any>
    {
        return (await axios.get(`scripts/config/${scriptId}/default`, {
            params: {
                moduleId: moduleId
            }
        })).data;
    }

    public static async createConfig(form: any, isDefaultMode: boolean, moduleId: string): Promise<void>
    {
        return (await axios.post(`simple-command/scripts-config`, { ...form, isDefaultMode }, {
            params: {
                moduleId: moduleId
            }
        })).data;
    }

    public static async updateConfig(configId: string, form: any, moduleId: string): Promise<void>
    {
        return (await axios.put(`simple-command/scripts-config/${configId}`, form, {
            params: {
                moduleId: moduleId
            }
        })).data;
    }
}

// schema
export interface SchemaSection {
    key: string;
    name: string;
    controls: SchemaControl[];
}

export interface SchemaControl {
    key: string;
    name: string;
    type: string;
    required: boolean;
    defaultValue?: any;
    additionalData?: any;
    reloadKey: number;
    relatedControls: SchemaControl[];
}

// form
export interface FormSection {
    sectionKey: string;
    controls: Record<string, FormControl>;
}

export interface FormModule {
    key: string;
    value: string;
    publicId: string;
}

export interface FormControl {
    key: string;
    type: string;
    value: any;
}

export interface ModuleField {
    key: string;
    fieldType: string;
    value: string;
}
